// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicInformation_basic-information__8EpDY {
  display: flex;
  align-items: center;
  align-self: stretch;
  background-color: #f8f8f8;
  border-bottom: 1px solid var(--light-grey);
  flex-direction: column;
}
.BasicInformation_basic-information__right__5CRqt {
  width: 100%;
  padding: 54px 16px 32px;
  position: relative;
  background-color: var(--background-color-2);
  gap: 4px;
}
.BasicInformation_basic-information__right__5CRqt .BasicInformation_images-seal-wrapper__IarDZ {
  overflow: hidden;
  position: absolute;
  top: 0;
  transform: translateY(-84px);
  padding: 2px;
  border-radius: 9999px;
  border: none;
  background-color: var(--background-color-2);
}
.BasicInformation_basic-information__left__hKyOC {
  align-self: stretch;
}
.BasicInformation_basic-information__left__hKyOC .BasicInformation_cover-img-wrapper__\\+DEdC {
  height: 30vh;
  width: 100%;
}
.BasicInformation_basic-information__left__hKyOC .BasicInformation_cover-img-wrapper__\\+DEdC img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_images-seal-wrapper__IarDZ {
  padding: 8px;
  border-radius: 8px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_images-seal-wrapper__IarDZ .BasicInformation_images-seal__GR\\+Qe {
  width: 119px;
  height: 118px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_name__0y0AL {
  width: fit-content;
  color: var(--accent-color-dark);
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_bio__90RYw {
  margin-top: 10px;
  color: var(--dark-grey);
  font-size: 14px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_bio--content__z-V4F {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_bio--see-more__kHV6K {
  width: fit-content;
  text-decoration: underline;
  cursor: pointer;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info__uCN1e {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  flex-wrap: wrap;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info__uCN1e .BasicInformation_collaboration-btn__I7zgY {
  margin-top: 10px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item__bEaNh {
  margin-top: 10px;
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--accent-color-dark);
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  text-transform: initial;
  line-height: 16px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--start-icon__eeABI {
  height: 16px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--start-icon__eeABI svg {
  width: 16px;
  height: 16px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--start-icon__eeABI svg path {
  fill: var(--accent-color-dark);
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--link-icon__tFQ6p {
  height: 16px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--link-icon__tFQ6p svg {
  width: 16px;
  height: 16px;
}
.BasicInformation_basic-information__8EpDY .BasicInformation_more-info--item--link-icon__tFQ6p svg path {
  stroke: var(--accent-color-dark);
}
@media only screen and (max-width: 480px) {
  .BasicInformation_basic-information__8EpDY {
    padding: 0;
    flex-direction: column;
    gap: 0;
  }
  .BasicInformation_basic-information__right__5CRqt {
    padding: 54px 16px 20px;
    position: relative;
    background-color: var(--background-color-2);
    gap: 4px;
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_images-seal-wrapper__IarDZ {
    overflow: hidden;
    position: absolute;
    top: 0;
    transform: translateY(-84px);
    padding: 2px;
    border-radius: 9999px;
    border: none;
    background-color: var(--background-color-2);
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_name__0y0AL {
    font-size: 20px;
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_bio--content__z-V4F {
    font-size: 12px;
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_more-info__uCN1e {
    margin-top: 20px;
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_more-info--item__bEaNh {
    font-size: 14px;
    padding: 10px 0;
    border-radius: 8px;
    flex: 1 1;
    color: white;
    background-color: var(--accent-color-dark);
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_more-info--item--start-icon__eeABI svg path {
    fill: white;
  }
  .BasicInformation_basic-information__right__5CRqt .BasicInformation_more-info--item--link-icon__tFQ6p svg path {
    stroke: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/BasicInformation/BasicInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;EACA,sBAAA;AACF;AAEE;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,2CAAA;EACA,QAAA;AAAJ;AAEI;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,4BAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,2CAAA;AAAN;AAIE;EACE,mBAAA;AAFJ;AAII;EACE,YAAA;EACA,WAAA;AAFN;AAIM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAFR;AAOE;EACE,YAAA;EACA,kBAAA;AALJ;AAOI;EACE,YAAA;EACA,aAAA;AALN;AASE;EACE,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AARJ;AAUI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AARN;AAWI;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AATN;AAaE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAZN;AAcM;EACE,YAAA;AAZR;AAcQ;EACE,WAAA;EACA,YAAA;AAZV;AAcU;EACE,8BAAA;AAZZ;AAiBM;EACE,YAAA;AAfR;AAiBQ;EACE,WAAA;EACA,YAAA;AAfV;AAiBU;EACE,gCAAA;AAfZ;AAsBE;EAxIF;IAyII,UAAA;IACA,sBAAA;IACA,MAAA;EAnBF;EAqBE;IACE,uBAAA;IACA,kBAAA;IACA,2CAAA;IACA,QAAA;EAnBJ;EAqBI;IACE,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,4BAAA;IACA,YAAA;IACA,qBAAA;IACA,YAAA;IACA,2CAAA;EAnBN;EAsBI;IACE,eAAA;EApBN;EAwBM;IACE,eAAA;EAtBR;EA0BI;IACE,gBAAA;EAxBN;EA0BM;IACE,eAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,YAAA;IACA,0CAAA;EAxBR;EA4BY;IACE,WAAA;EA1Bd;EAiCY;IACE,aAAA;EA/Bd;AACF","sourcesContent":[".basic-information {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid var(--light-grey);\n  flex-direction: column;\n\n\n  &__right {\n    width: 100%;\n    padding: 54px 16px 32px;\n    position: relative;\n    background-color: var(--background-color-2);\n    gap: 4px;\n\n    .images-seal-wrapper {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      transform: translateY(-84px);\n      padding: 2px;\n      border-radius: 9999px;\n      border: none;\n      background-color: var(--background-color-2);\n    }\n  }\n\n  &__left {\n    align-self: stretch;\n\n    .cover-img-wrapper {\n      height: 30vh;\n      width: 100%;\n\n      img {\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .images-seal-wrapper {\n    padding: 8px;\n    border-radius: 8px;\n\n    .images-seal {\n      width: 119px;\n      height: 118px;\n    }\n  }\n\n  .name {\n    width: fit-content;\n    color: var(--accent-color-dark);\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0;\n    line-height: 1.2;\n  }\n\n  .bio {\n    margin-top: 10px;\n    color: var(--dark-grey);\n    font-size: 14px;\n\n    &--content {\n      display: -webkit-box;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      cursor: pointer;\n    }\n\n    &--see-more {\n      width: fit-content;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n\n  .more-info {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n    flex-wrap: wrap;\n\n    .collaboration-btn {\n      margin-top: 10px;\n    }\n\n    &--item {\n      margin-top: 10px;\n      padding: 4px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      color: var(--accent-color-dark);\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n      text-transform: initial;\n      line-height: 16px;\n\n      &--start-icon {\n        height: 16px;\n\n        svg {\n          width: 16px;\n          height: 16px;\n\n          path {\n            fill: var(--accent-color-dark);\n          }\n        }\n      }\n\n      &--link-icon {\n        height: 16px;\n\n        svg {\n          width: 16px;\n          height: 16px;\n\n          path {\n            stroke: var(--accent-color-dark);\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    padding: 0;\n    flex-direction: column;\n    gap: 0;\n\n    &__right {\n      padding: 54px 16px 20px;\n      position: relative;\n      background-color: var(--background-color-2);\n      gap: 4px;\n\n      .images-seal-wrapper {\n        overflow: hidden;\n        position: absolute;\n        top: 0;\n        transform: translateY(-84px);\n        padding: 2px;\n        border-radius: 9999px;\n        border: none;\n        background-color: var(--background-color-2);\n      }\n\n      .name {\n        font-size: 20px;\n      }\n\n      .bio {\n        &--content {\n          font-size: 12px;\n        }\n      }\n\n      .more-info {\n        margin-top: 20px;\n\n        &--item {\n          font-size: 14px;\n          padding: 10px 0;\n          border-radius: 8px;\n          flex: 1;\n          color: white;\n          background-color: var(--accent-color-dark);\n\n          &--start-icon {\n            svg {\n              path {\n                fill: white;\n              }\n            }\n          }\n\n          &--link-icon {\n            svg {\n              path {\n                stroke: white;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basic-information": `BasicInformation_basic-information__8EpDY`,
	"basic-information__right": `BasicInformation_basic-information__right__5CRqt`,
	"images-seal-wrapper": `BasicInformation_images-seal-wrapper__IarDZ`,
	"basic-information__left": `BasicInformation_basic-information__left__hKyOC`,
	"cover-img-wrapper": `BasicInformation_cover-img-wrapper__+DEdC`,
	"images-seal": `BasicInformation_images-seal__GR+Qe`,
	"name": `BasicInformation_name__0y0AL`,
	"bio": `BasicInformation_bio__90RYw`,
	"bio--content": `BasicInformation_bio--content__z-V4F`,
	"bio--see-more": `BasicInformation_bio--see-more__kHV6K`,
	"more-info": `BasicInformation_more-info__uCN1e`,
	"collaboration-btn": `BasicInformation_collaboration-btn__I7zgY`,
	"more-info--item": `BasicInformation_more-info--item__bEaNh`,
	"more-info--item--start-icon": `BasicInformation_more-info--item--start-icon__eeABI`,
	"more-info--item--link-icon": `BasicInformation_more-info--item--link-icon__tFQ6p`
};
export default ___CSS_LOADER_EXPORT___;
